import ajaxRequest from 'utils/_ajax-request.js'

export default () => {
  const notificationBells = document.querySelectorAll('.order-list-admin__notification-not-read')
  if( notificationBells ) {
    notificationBells.forEach((element)=>{
      element.addEventListener('click', (event)=>{
        const orderId = element.closest('tr').getAttribute('data-id')
        element.classList.add('process')

        let openUrl = '/{!_locale}/admin/orders/{!id}/set-notification-not-read'
        openUrl = openUrl.replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
          .replaceAll('{!id}', orderId)

        ajaxRequest(
          (xhr, error) => {
            element.classList.remove('process')
            element.closest('td').classList.add('order-list-admin__value-notification--alert')
          },
          (openUrl+'?ajax=1'),
          {},
          'POST'
        )
      })
    })
  }
}
